// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2LZNz","col":"Table_col__2ooBJ","fulfillmentStatus":"Table_fulfillmentStatus__2rBrU","emailCol":"Table_emailCol__2Ip2W"};